import React from 'react';

import Drawer from '../components/Drawer';
import VideoTask from '../components/VideoTask/VideoTask';

function VideoExercise() {
  return (
    <div>
      <Drawer>
        <VideoTask />
      </Drawer>
    </div>
  );
}

export default (VideoExercise);
